
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/saxo_mission",
      function () {
        return require("private-next-pages/p/saxo_mission/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/saxo_mission"])
      });
    }
  